export enum SortTypesEnum {
  customSort = 0,
  mostRecentMessageFirst = 1,
  mostRecentMessageLast = 2,
  mostRecentConversationFirst = 3,
  mostRecentConversationLast = 4,
  mostRecentDiscussionFirst = 5,
  mostRecentDiscussionLast = 6,
  mostFollowersFirst = 200,
  mostFollowersLast = 201,
}
